import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Tooltip,  } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import {permissionsConstans} from '../../constansPermissions'
import EditCharge from './editCharges';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
    pointerEvents: 'auto'
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "100%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default function DetailedTable({
  headers,
  data,
  onView,
  refreshCharge,
  chargesActive,
  onDelete,
}) {
 
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [chargeId, setChargeId] = useState('');
  const [fieldToEdit, setFieldToEdit] = useState('')
  const classes = useStyles();
  const id = IdKey.generate();

  const validationPermission = () => {
    const state = JSON.parse(localStorage.getItem("state"))
    const module = state?.permissions.find((x)=> x.code === 'CAR')
 
    
   if(module?.functionalities?.some((x)=> x === permissionsConstans.CAR_EDITAR)){
      return  <div className={classes.columnEvent}>
                <Tooltip title="Editar" arrow placement="top">
                  <EditIcon
                    onFocus={(event) => event.stopPropagation()}
                    onClick={() => {setChargeId(data.id); setOpenModalEdit(true);  setFieldToEdit(id)}}
                    className={classes.iconEvent}
                  />
                </Tooltip>
              </div>
   }
   }
  const getValueByKey = (object, header) => {
       if(header.field === 'chargeApprovers'){
        if ( object[header.field] ){
          
        const approversList = object[header.field];
        const approvers= [];
       return approversList.map(x => {
          const item = chargesActive.find(c => c?.id === x);
          if(item) approvers.push(item);   
          return x.denomination;      
         }).join(', ');
        //  return approvers.map((x) => <div>{x.denomination}</div>)
        }
      }
     
    if (header.child === null) {
      return object[header.field] !== null ? object[header.field] : "";
    }
    return object[header.field] !== null
      ? object[header.field]
      : "";
  };

  const stateFieldEdit = (x) => setOpenModalEdit(x);
  return (
    <div className={classes.root}>
             <Accordion style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13',  marginTop: "10px",}}>
                
             <AccordionSummary aria-controls="panel1c-content" id={id}>
               {headers.initialHeaders.map((header) => (
                 <div className={classes.column}>
                   <Typography className={classes.heading}>
                     {header.title}
                   </Typography>
                   <Typography className={classes.secondaryHeading}>
                     {getValueByKey(data, header)}
                   </Typography>
                 </div>
               ))}
                 {validationPermission()}
             </AccordionSummary>
             
             <AccordionDetails className={classes.details}>
             <div className={classes.rootGrid}>
              {openModalEdit && fieldToEdit === fieldToEdit ? <EditCharge 
                  id={chargeId} 
                  stateFieldEdit = { stateFieldEdit }
                  refresh = { refreshCharge }
                  chargesActive = { chargesActive }
                  closeOpenEdit = { stateFieldEdit }
                  /> 
                  : ''
              }
          </div>     
        </AccordionDetails>
           </Accordion>
    </div>
  );
}
